<template>
  <div class="background" :style="backgroundStyle">
    <div class="center-content">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundImage from '../assets/background/bg_login.png';

export default {
  name: 'dx-login-modal',
  data() {
    return {
      backgroundStyle: {
        backgroundImage: `url(${backgroundImage})`,
      },
    };
  },
};
</script>

<style scoped lang="scss">
  .background{
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: auto;

    .center-content{
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100%;

      .content {
        padding: var(--dx-space-size--sm);
        border-radius: 3px;
      }
    }
  }
</style>
